import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Public site config: shipping zones, pre-order notice, batch counter, media slots.
export const useSiteConfig = () => {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => setConfig({}));
  }, []);
  return config;
};
